import _ from "lodash";

export type LinkHandlers = Record<string, () => void>;

export const replaceLinks = (
  text: string,
  capitalizeLinks: boolean = true,
  handlers: LinkHandlers = {}
) => {
  return text
    .split(/(\{\{[^{}]+}}|{[^{}]+})/g)
    .map((part, index) => {

      const actionMatch = part.match(/^{{([^{}]+)}}$/);

      if (actionMatch) {
        const action = actionMatch[1];
        const handlerName = `open${_.upperFirst(action)}`;

        return (
          <a
            key={index}
            href="#"
            className="text-blue-600 underline cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              handlers[handlerName]?.();
            }}
          >
            {capitalizeLinks ? _.startCase(action) : action}
          </a>
        );
      }

      const linkMatch = part.match(/^{([^{}]+)}$/);

      if (linkMatch) {
        const link = linkMatch[1];

        return (
          <a
            key={index}
            href={`/${link}`}
            className="underline cursor-pointer transition duration-200 hover:text-generic-hover hover:scale-105"
          >
            {capitalizeLinks ? _.startCase(link) : link}
          </a>
        );
      }

      return part;
    });
};